import type { SVGProps } from 'react';

interface SVGRProps {
  readonly title?: string;
  readonly titleId?: string;
}

const SvgIconOutlineCheck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={47}
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#32353B"
      d="m20.295 27.375-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41z"
    />
    <rect
      width={46.333}
      height={46.333}
      x={0.333}
      y={0.333}
      stroke="#32353B"
      strokeOpacity={0.2}
      strokeWidth={0.667}
      rx={11.667}
    />
  </svg>
);

export default SvgIconOutlineCheck;
